import Vue from 'vue'
import Router from 'vue-router'
import LandingPage from '@/components/LandingPage'
import SolarPath from '@/components/ZmanimSolarPath'
import ZmanimList from '@/components/ZmanimList'
import ZmanimClock from '@/components/ZmanimClock'
import ZmanimCalculationsList from '@/components/ZmanimCalculationsList'
import AppSupport from '@/components/AppSupport'
import AppPrivacy from '@/components/AppPrivacy'
import AppComponentSandbox from '@/components/AppComponentSandbox'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: "/about",
    //   name: "about",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/About.vue")
    // },
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage
    },
    {
      path: '/about/privacy',
      name: 'Privacy',
      component: AppPrivacy
    },
    {
      path: '/support',
      name: 'Support',
      component: AppSupport
    },
    {
      path: '/about/calculations',
      name: 'Calculations',
      component: ZmanimCalculationsList
    },
    {
      path: '/solarpath',
      component: SolarPath
    },
    {
      path: '/list',
      component: ZmanimList
    },
    {
      path: '/clock',
      component: ZmanimClock
    },
    {
      path: '/sandbox/:component',
      component: AppComponentSandbox
    }
  ]
})
